import { fetchAPI } from "./baseApi";

// ============================================================
// ADMIN MANAGEMENT (Level 1 only)
// ============================================================

export async function createAdmin(adminData) {
  return fetchAPI("/admin-auth/admin/create", {
    method: "POST",
    body: JSON.stringify(adminData),
  });
}

export async function updateAdmin(adminId, updateData) {
  return fetchAPI(`/admin-auth/admin/${adminId}`, {
    method: "PUT",
    body: JSON.stringify(updateData),
  });
}

export async function resetAdminPassword(adminId, newPassword) {
  return fetchAPI(`/admin-auth/admin/${adminId}/reset-password`, {
    method: "POST",
    body: JSON.stringify({ newPassword }),
  });
}

export async function deleteAdmin(adminId) {
  return fetchAPI(`/admin-auth/admin/${adminId}`, {
    method: "DELETE",
  });
}

export async function getAllAdmins() {
  return fetchAPI("/admin-auth/admin/list");
}

export async function getAuditHistory(filters = {}) {
  const params = new URLSearchParams();
  if (filters.adminId) params.append("adminId", filters.adminId);
  if (filters.actionType) params.append("actionType", filters.actionType);
  if (filters.startDate) params.append("startDate", filters.startDate);
  if (filters.endDate) params.append("endDate", filters.endDate);

  const queryString = params.toString();
  return fetchAPI(`/admin-auth/audit-history${queryString ? `?${queryString}` : ""}`);
}
